import script from "./ElementAnimationPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementAnimationPanel.vue?vue&type=script&lang=ts&setup=true"

import "./ElementAnimationPanel.vue?vue&type=style&index=0&id=2f69234f&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f69234f"]])

export default __exports__